import React from 'react'
import { Chip, Tooltip } from '@mui/material'
import { VisibilityOffOutlined } from '@mui/icons-material'
import { useAuth } from '../../../contexts/AuthContext'
import { fpUserCanAccess } from '../../../config/fpUserAccess'

type Source =
  | { kind: 'tool'; id: string }
  | { kind: 'exception'; visibleToRoles: string[] | null | undefined }

type Props = Source & {
  variant?: 'icon' | 'chip'
  size?: 'medium' | 'large'
}

const shouldRenderCue = (source: Source): boolean => {
  if (source.kind === 'tool') return !fpUserCanAccess('tool', source.id)
  if (source.visibleToRoles == null) return false
  return !source.visibleToRoles.includes('FP_USER')
}

const FpVisibilityIcon: React.FC<Props> = (props) => {
  const { user } = useAuth()
  const { variant = 'icon', size = 'medium', ...source } = props
  if (user?.role === 'FP_USER') return null
  if (!shouldRenderCue(source as Source)) return null

  if (variant === 'chip') {
    const isLarge = size === 'large'
    return (
      <Tooltip title="Not visible to Franchise Partners">
        <Chip
          icon={<VisibilityOffOutlined sx={{ fontSize: isLarge ? 15 : 16 }} />}
          label="PSC Only"
          variant="outlined"
          sx={{
            height: isLarge ? 22 : 24,
            fontSize: isLarge ? '0.66rem' : '0.72rem',
            fontWeight: 600,
            color: 'grey.800',
            backgroundColor: 'grey.300',
            borderColor: 'grey.400',
            position: 'relative',
            top: isLarge ? '3px' : 0,
            '& .MuiChip-icon': {
              color: 'inherit',
              marginLeft: '6px',
              marginRight: '-4px',
            },
          }}
        />
      </Tooltip>
    )
  }

  return (
    <Tooltip title="Not visible to Franchise Partners">
      <VisibilityOffOutlined
        aria-label="Not visible to Franchise Partners"
        sx={{
          fontSize: 15,
          color: 'text.secondary',
          ml: 0.5,
          verticalAlign: 'middle',
        }}
      />
    </Tooltip>
  )
}

export default FpVisibilityIcon
